var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"adminHeader"},[_c('LogoSvg',{staticClass:"adminHeader__logo"}),(_vm.menu)?_c('Menu'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }